;(function () {
  angular.module('contrast.libraries').controller('LibraryCtrl', LibraryCtrl)

  function LibraryCtrl($scope, $rootScope, LibraryFactory) {
    'ngInject'

    angular.extend($scope, {
      libraries: {},
      statsLoaded: false,
      // Toggled via the statsToggle directive
      statsVisible: false
    })

    angular.extend($scope, {
      getStats: getStats
    })

    function getStats() {
      if (!$scope.statsLoaded) {
        LibraryFactory.getLibrariesStats().then(function (response) {
          var data = response.data
          $scope.statsLoaded = true
          $scope.libraries.stats = data.stats
          $scope.libraries.vulns = data.stats.total_vulnerabilities > 0
        })
      }
    }

    $scope.$on('$destroy', function () {
      // CONTRAST-26156 Required for custom footer
      $rootScope.$broadcast('changeFooterBottom', { shouldSendToBottom: false })
    })
  }
})()
